import React from "react";

import clsx from "clsx";

import Skeleton from "@busbud/design-system-components/dist/Skeleton/Skeleton";
import { Label } from "@busbud/horizon";

import { LocalizedPrice } from "@app/components/localized-price";
import type { CurrencyCode } from "@app/types/currency";

export interface LineItemProps {
  amount: number;
  bold_price?: boolean;
  className?: string;
  currency_code: CurrencyCode;
  data_testid?: string;
  is_loading?: boolean;
  label: string;
  negative?: boolean;
  size?: "md" | "lg";
  tooltip?: React.ReactNode;
}

export const LineItem: React.FC<LineItemProps> = ({
  amount,
  bold_price = false,
  className,
  currency_code,
  data_testid,
  is_loading = false,
  label,
  negative = false,
  size = "md",
  tooltip
}) => (
  <div
    className={clsx("flex flex-row justify-between", className)}
    data-testid={data_testid}
  >
    <Label as="span" size={size} fontWeight="bold" iconEnd={tooltip}>
      {label}
    </Label>
    <Label as="span" size={size} fontWeight={bold_price ? "bold" : "regular"}>
      {is_loading ? (
        <Skeleton
          animation="wave"
          size="sm"
          width={size === "lg" ? "9" : "6"}
          variant="rectangular"
        />
      ) : (
        <>
          {!!negative && "-"}
          <LocalizedPrice price_in_cents={amount} currency={currency_code} />
        </>
      )}
    </Label>
  </div>
);
